// Cadastro de cliente a partir de um lead (recomendação aprovada pelo Kaio em 01/10).
//
// O agente de IA cria o lead com só o nome da empresa em texto e os contatos que a conversa trouxe, sem
// cliente. Para fazer proposta a pessoa precisa de um cliente com cadastro fiscal; em vez de digitar o
// nome de novo em Clientes, o "Cadastrar cliente" do lead abre o cadastro já preenchido e, ao salvar,
// vincula o cliente novo ao lead (`aoCriar`).
//
// Quem cria o cliente aqui é quem tem `clientes.create`; o closer não tem, e a tela diz a quem pedir.

// O que vai para NewClienteModal. O tipo segue o funil: no de projetos o cliente cadastrado é o final
// (pagador), mesmo que o negócio venha de um canal (o canal é o especificador, outro vínculo); no de
// lojistas é o lojista.
function opcoesDeCadastroDoCliente(lead, aoCriar) {
  const texto = (v) => (v == null ? '' : String(v));
  return {
    prefill: {
      nome: texto(lead?.empresa),
      contato: texto(lead?.contato),
      email: texto(lead?.email),
      telefone: texto(lead?.telefone),
    },
    defaultTipo: lead?.funil === 'lojistas' ? 'lojista' : 'projeto_direto',
    aoCriar,
  };
}

export { opcoesDeCadastroDoCliente };
